import { messageFromApiErrorBody, readJsonResponseBody } from '@commenda/utils';
import { DOCUMENT_ASSEMBLER_TEMPLATE_VERSION_NOT_USABLE_ERROR_CODE } from './helpers';
import {
  IDocumentAssemblerRenderedError,
  TDocumentAssemblerVersionRefusal,
} from './types';

export const readDocumentAssemblerVersionRefusal = async (
  response: Response,
  fallbackMessage: string
): Promise<TDocumentAssemblerVersionRefusal> => {
  const body = (await readJsonResponseBody(response)) as {
    errorCode?: string;
    message?: string;
    errors?: IDocumentAssemblerRenderedError[];
  };

  if (
    body?.errorCode ===
      DOCUMENT_ASSEMBLER_TEMPLATE_VERSION_NOT_USABLE_ERROR_CODE &&
    Array.isArray(body.errors) &&
    body.errors.length > 0
  ) {
    return {
      kind: 'NOT_USABLE',
      message: body.message ?? fallbackMessage,
      errors: body.errors,
    };
  }

  return {
    kind: 'MESSAGE',
    message: messageFromApiErrorBody(body, fallbackMessage),
  };
};
